import type { ValkyrieLambda } from 'config-editor-common';

/**
 * Collects all queue names referenced by endpoint and queue consumer lambdas.
 */
function addIfNonEmpty(refs: Set<string>, q: string) {
  if (q && typeof q === 'string' && q.trim()) refs.add(q.trim());
}

function addQueuesFromLambda(refs: Set<string>, l: ValkyrieLambda) {
  for (const q of l.sqs_send_policies ?? []) addIfNonEmpty(refs, q);
  for (const q of l.sqs_receive_policies ?? []) addIfNonEmpty(refs, q);
  for (const q of Object.values(l.sqs_queue_urls ?? {})) {
    if (typeof q === 'string') addIfNonEmpty(refs, q);
  }
}

export function getQueuesReferencedByLambdas(
  endpointLambdas: Record<string, ValkyrieLambda>,
  queueConsumerLambdas: Record<string, ValkyrieLambda>,
): Set<string> {
  const refs = new Set<string>();
  for (const l of Object.values(queueConsumerLambdas)) {
    if (l?.sqs_queue) addIfNonEmpty(refs, l.sqs_queue);
    addQueuesFromLambda(refs, l);
  }
  for (const l of Object.values(endpointLambdas)) {
    addQueuesFromLambda(refs, l);
  }
  return refs;
}

/**
 * Returns queue names that are referenced by lambdas but not in the defined list.
 */
export function getValkyrieRemovedQueues(
  queuesReferenced: Set<string>,
  definedQueueNames: string[] | Set<string>,
): string[] {
  const defined = definedQueueNames instanceof Set ? definedQueueNames : new Set(definedQueueNames);
  return [...queuesReferenced].filter(q => q && q.trim() && !defined.has(q));
}
